// v2 campaign lane file — see app/v2/README.md. Owned by one build agent at a time;
// other agents and humans: do not edit. Routes here are HIDDEN (reachable only via
// /v2-screens and deep links) and every element must wrap in <RequireAuth>.
import { lazy, type ReactElement } from 'react';
import { Route } from 'react-router-dom';
import { RequireAuth } from '@/shared/auth/RequireAuth';

const ContentsMaint2Page = lazy(
  () => import('@/features/inventory/contents2/ContentsMaint2Page'),
);
const Chold2Page = lazy(() => import('@/features/rewarehousing/chold2/Chold2Page'));
const LocAssign2Page = lazy(
  () => import('@/features/rewarehousing/locassign2/LocAssign2Page'),
);
const CycMaster2Page = lazy(() => import('@/features/cyc/master2/CycMaster2Page'));
const CycGenerate2Page = lazy(() => import('@/features/cyc/generate2/CycGenerate2Page'));
// One component, two windows — exactly as the faithful MoversPage serves w_mover_ws and
// w_mover_rf through two 1-line wrappers.
const Movers2WsPage = lazy(() => import('@/features/movers/v2/Movers2WsPage'));
const Movers2RfPage = lazy(() => import('@/features/movers/v2/Movers2RfPage'));
// wave 3
const WorkSearch2Page = lazy(() => import('@/features/work/search2/WorkSearch2Page'));
const ProdStatus2Page = lazy(
  () => import('@/features/production-status/v2/ProdStatus2Page'),
);
const Velocity2Page = lazy(() => import('@/features/rewarehousing/velocity2/Velocity2Page'));

export const slot4Routes: ReactElement[] = [
  <Route
    key="/inventory/contents2"
    path="/inventory/contents2"
    element={
      <RequireAuth>
        <ContentsMaint2Page />
      </RequireAuth>
    }
  />,
  <Route
    key="/rewarehousing/chold2"
    path="/rewarehousing/chold2"
    element={
      <RequireAuth>
        <Chold2Page />
      </RequireAuth>
    }
  />,
  <Route
    key="/rewarehousing/location-assignment2"
    path="/rewarehousing/location-assignment2"
    element={
      <RequireAuth>
        <LocAssign2Page />
      </RequireAuth>
    }
  />,
  <Route
    key="/cyc/master2"
    path="/cyc/master2"
    element={
      <RequireAuth>
        <CycMaster2Page />
      </RequireAuth>
    }
  />,
  <Route
    key="/cyc/generate2"
    path="/cyc/generate2"
    element={
      <RequireAuth>
        <CycGenerate2Page />
      </RequireAuth>
    }
  />,
  <Route
    key="/movers/ws2"
    path="/movers/ws2"
    element={
      <RequireAuth>
        <Movers2WsPage />
      </RequireAuth>
    }
  />,
  <Route
    key="/movers/rf2"
    path="/movers/rf2"
    element={
      <RequireAuth>
        <Movers2RfPage />
      </RequireAuth>
    }
  />,
  <Route
    key="/work/search2"
    path="/work/search2"
    element={
      <RequireAuth>
        <WorkSearch2Page />
      </RequireAuth>
    }
  />,
  <Route
    key="/inquiry/production-status2"
    path="/inquiry/production-status2"
    element={
      <RequireAuth>
        <ProdStatus2Page />
      </RequireAuth>
    }
  />,
  <Route
    key="/rewarehousing/velocity2"
    path="/rewarehousing/velocity2"
    element={
      <RequireAuth>
        <Velocity2Page />
      </RequireAuth>
    }
  />,
];
